import { LegalLayout } from "@/components/legal/legal-layout";
import { parseLegalDocument } from "@/lib/legal-markdown";
import termsOfUseSource from "@/content/legal/terms-of-use.md?raw";

/**
 * This page renders a truthful current-state Terms of Use for the public
 * website only (apps/web/src/content/legal/terms-of-use.md) — not the
 * internal comprehensive SaaS draft at docs/14-terms-of-use-draft.md, which
 * remains as future-state documentation and is never shipped to the site.
 * The current-state Terms describe only the informational website (no paid
 * service, no liability cap or governing-law clause is needed yet), so
 * there is nothing to flag via the "to be finalized" callout mechanism in
 * lib/legal-markdown.tsx.
 */
const PLACEHOLDER_MARKERS: string[] = [];

export function TermsPage() {
  const doc = parseLegalDocument(termsOfUseSource, PLACEHOLDER_MARKERS);

  return (
    <LegalLayout
      title="Terms of Use"
      statusNote={doc.statusNote}
      lastUpdated={doc.lastUpdated}
      headings={doc.headings}
    >
      {doc.body}
    </LegalLayout>
  );
}
